import { createValidation } from '../../utils/validation';
import supplierConfig from './supplierConfig';

// Create validation factory for Supplier entity
const createSupplierValidation = () => {
  return createValidation(supplierConfig.fields);
};

// Export both the factory and a default instance
export const validateSupplierData = createSupplierValidation();
export const createSupplierValidationSchema = createSupplierValidation;
export default createSupplierValidation;
